<!--
  @component
  Generates an SVG multi-series line chart. It expects your data to be an array of objects, each with a `values` key that is an array of data objects.
 -->
<script>
	import { draw, fade } from "svelte/transition";
	import { tweened } from "svelte/motion";
	import { quintOut } from "svelte/easing";
	import { getContext, onMount, onDestroy } from "svelte";
	import { interpolateString } from "d3-interpolate";

	export let path;
	export let lineDrawDuration;
	export let group;
	export let rendered;

	const { data, xGet, yGet, zGet, zDomain, zRange } = getContext("LayerCake");

	let tD = tweened(path(group.values), { interpolate: interpolateString, duration: 300 });
	$: targetD = path(group.values);
	$: tD.set(targetD, { interpolate: interpolateString, duration: 300 });

	onDestroy(() => {
		rendered = false;
	});
</script>

<path
	in:draw={group.settings.faded ? { duration: 0 } : { duration: lineDrawDuration, delay: 200, ease: quintOut }}
	on:introend={() => (rendered = true)}
	class="path-line"
	d={$tD}
	stroke={$zGet(group)}
	stroke-opacity={group.settings.faded ? 0.2 : 1}
/>

<style lang="scss">
	.path-line {
		fill: none;
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 1.5px;
		opacity: 0.8;

		@media (min-width: $breakpoint-tablet-s) {
			stroke-width: 3px;
			opacity: 1;
		}
	}

	.point {
		stroke: #fff;
		stroke-width: 1px;
	}
</style>
